import { RouterOutlet } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NavigationMainComponent } from '../components/navigation-main/navigation-main.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    standalone: true,
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [FooterComponent, NavigationMainComponent, RouterOutlet],
})
export class MainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
